(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;

  const initializeReveal = (root = document) => {
    const elements = root.querySelectorAll('[data-acx-reveal]:not([data-acx-ready])');
    if (!elements.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.acxReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    document.documentElement.classList.add('acx-motion');
    revealObserver ||= new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    elements.forEach((element) => {
      element.dataset.acxReady = 'true';
      revealObserver.observe(element);
    });
  };

  const initializeHeader = () => {
    const headerSection = document.querySelector('.shopify-section-header');
    if (!headerSection || headerSection.dataset.acxHeader === 'true') return;
    headerSection.dataset.acxHeader = 'true';

    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => headerSection.classList.toggle('acx-scrolled', window.scrollY > 12));
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  const initialize = (root = document) => {
    initializeReveal(root);
    initializeHeader();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
